import { createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";

//PUT per mettere file su S3
export const uploadFile = createAsyncThunk(
  "uploadFile/upload",
  async ({ url, file, type }) => {
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": type,
        },
        body: file,
      });
      if (response.ok) {
        return response.url;
      } else {
        throw new Error(
          "Errore durante il caricamento del file su Azure Blob Storage"
        );
      }
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

//POST per creare documento a backend
export const createDocument = createAsyncThunk(
  "createDocument/create",
  async (documentData) => {
    // Pulisci l'URL prima di utilizzarlo nella richiesta POST
    const cleanedUrl = documentData.s3FilesPath.split("?")[0];
    const cleanedDocumentData = {
      ...documentData,
      s3FilesPath: [cleanedUrl],
    };
    try {
      const endpoint = "documents/create";
      const response = await client.post(endpoint, cleanedDocumentData);
      return response.data;
    } catch (error) {
      throw new Error("Errore durante la creazione del documento");
    }
  }
);

// Azione asincrona per ottenere l'URL di upload
export const getUploadURL = createAsyncThunk(
  "documentUrl/getDocumentUrl",
  async () => {
    try {
      //userId?
      const response = await client.get(`documents/getuploadurl`);
      const uploadUrl = response.data.Data; // Estrai l'URL dalla proprietà Data
      return uploadUrl;
    } catch (error) {
      // Gestisci eventuali errori nella chiamata API
      throw new Error("Errore durante il recupero dell'URL di upload");
    }
  }
);
